import { render, staticRenderFns } from "./label-row.vue?vue&type=template&id=c5d85dbe&scoped=true"
import script from "./label-row.vue?vue&type=script&setup=true&lang=js"
export * from "./label-row.vue?vue&type=script&setup=true&lang=js"
import style0 from "./label-row.vue?vue&type=style&index=0&id=c5d85dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d85dbe",
  null
  
)

export default component.exports